import { useEffect, useState } from "react";

const PaymentMethod = () =>{

    return(<> 
    
   
  
    {/* <!-- Breadcumb Section Start --> */}
    <div className="breadcrumb-img">
     <img src="assets/img/banner/payment-options-banner.jpg" alt="MeriPustak-payment-options"/>
       
    </div>

    {/* <!-- About Section Start --> */}
    <section className="about-section fix section-padding">
        <div className="container">
            <div className="about-wrapper">
			
                <br/><div className="row g-4 align-items-center bg-light-brown">
                   
                    <div className="col-md-12">
                        <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s"><b>MeriPustak</b> (Unit of Machwan Tech Services Private Limited) is using India one of the best &amp; highly secured payment gateway for online transactions </p>
                       <h5 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s"><b>Payment Getaways are given below:</b></h5>
                         <ul className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s" style={{padding: "10px 35px"}}>
                                <li>1. Pay U &amp; Pay Pal</li>
                                <li>2. Paynimo - TechProcess Payment Services (&nbsp;Ingenico ePayments India Private Limited)  </li>
                            </ul>
                    </div>
               
                </div><br/>
				<div className="row g-4 align-items-center">
                    <div className="col-md-12">
                        <h2 className="mt-3 mt-md-0 wow fadeInUp bg-green" data-wow-delay=".5s"><b>SECURITY:</b> </h2><br/>
                        <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">our payment partners follows stringent data security standards which include</p>
                         <ul className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s" style={{padding: "10px 35px"}}>
                                <li> <b>DATA ENCRYPTION:</b> SSL security certificate from VeriSign ensures that all transaction data that is transmitted or received is always transmitted in a secure encrypted form</li>
                                <li>Data security and process standardisation and compliance in our partner’s operation has been further re-enforced through additional ISO 9001:2000 and ISO 27001 certifications.</li>
                            </ul>
                    </div>
                </div>
				<br/>
				
				<div className="row g-4 align-items-center">
                    <div className="col-md-12">
                        <h4 className="mt-3 mt-md-0 wow fadeInUp bg-yellow" data-wow-delay=".5s"><b>Very Important Step before making any payment </b> </h4><br/>
                        <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">We never store or ask for your card/bank account number PIN, CVV or any payment details this is our strict policy if any one asking this please reach us immediately </p>
                       
                    </div>
					
                </div>
				
				<div className="row g-4 align-items-center bg-light">
                      
                    <div className="col-md-6 ">
                        <br/> <h5 className="mt-3 mt-md-0 wow fadeInUp bg-yellow" data-wow-delay=".5s"><b>Avoid public Wi-Fi/computers</b> </h5><br/>
                        <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Never do financial transactions on a public Wi-Fi. Hackers can intrude easily into a public WI-Fi network and steal your login details. If you need to make a financial transaction when you are out, use your own mobile phone network.</p>
                       
                    </div>
                    <div className="col-md-6">
                         <br/><h5 className="mt-3 mt-md-0 wow fadeInUp bg-yellow" data-wow-delay=".5s"><b>Keep your data to yourself</b> </h5><br/>
                        <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Don't save your bank and personal details in a browser or a payment site. Type the information whenever you make a transaction. Don't forget to log out every time you log in</p>
                       
                    </div>
                </div><br/>
				<div className="row g-4 align-items-center bg-light-blue">
                      
                     <div className="col-md-12">
                         <h5 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s"><b>Our Payment options are given below </b> </h5><br/>
                        <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Go cashless with digital payment option. For every DIGITAL PURCHASE on Meripustak. You will get 1% e-CASH.</p>
                       
                    </div>
                </div>
				<div className="row  g-4 align-items-center">
                      
                     <div className="col-md-12">
                         <br/><h5 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s"><b><h4>Credit + Debit Card</h4> </b> </h5><br/>
                      
                    </div>
                </div><br/>
				<div className="row g-4 align-items-center bg-light-yellow">
                    <div className="col-md-6">
                          <h4 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">1. Credit Cards</h4><br/>
                        <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                            We accept payments made using Visa, MasterCard and Maestro credit cards.<br/>
                            To pay using your credit card at checkout, you will need your card number, expiry
                            date, three-digit CVV number (found on the backside of your card). After entering
                            these details, you will be redirected to the bank's page for entering the online
                            3D Secure password.
                        </p>
                    </div>
                     <div className="col-md-6" style={{borderLeft:"1px solid"}}>
                          <h4 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">2. Debit cards</h4><br/>
                         <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                            We accept payments made using Visa, MasterCard and Maestro debit cards.<br/>
                            To pay using your debit card at checkout, you will need your card number, expiry
                            date (optional for Maestro cards), three-digit CVV number (optional for Maestro
                            cards). You will then be redirected to your bank's secure page for entering your
                            online password (issued by your bank) to complete the payment.</p>
                     </div>
                </div><br/><br/>
				<div className="row g-4 align-items-center bg-light-blue">
                    <div className="col-md-6">
                          <h4 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">3. Net Banking</h4><br/>
                        <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">We offer the convenience of using Internet banking service in order to make payment
                            of your order. Using net banking you can conduct a highly secured transactions.
                            Once the order is been placed, you will get redirected to your bank netbanking page
                            where you can proceed further and complete the transaction. We offer all major Indian
                            banks services for a smooth and hassle free transaction.</p>
                    </div>
                     <div className="col-md-6" style={{borderLeft:"1px solid"}}>
                          <h4 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">4. Paytm</h4><br/>
                         <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                            We accept payments made using Visa, MasterCard and Maestro debit cards.<br/>
                            To pay using your debit card at checkout, you will need your card number, expiry
                            date (optional for Maestro cards), three-digit CVV number (optional for Maestro
                            cards). You will then be redirected to your bank's secure page for entering your
                            online password (issued by your bank) to complete the payment.</p>
                     </div>
                </div><br/><br/>
				<div className="row g-4 align-items-center bg-light-yellow">
                    <div className="col-md-6">
                          <h4 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">5. Cheque Payment</h4><br/>
                         <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                            To make your payment more easy we have started accepting cheque. You can handover the cheque
                             instead of cash at the time delivery. We request you to please cross check the amount before
                              putting amount on the cheque for smooth service. Chequeshould be drawn in favor of “Machwan Tech Services Private Limited".
                        </p>
                    </div>
                      <div className="col-md-6" style={{borderLeft:"1px solid"}}>
                          <h4 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">6. Cash On Delivery</h4><br/>
                        <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                            If you are not comfortable making an online payment on MeriPustak.com, you can opt
                            for the Cash on Delivery <strong>(COD)</strong> payment method. With <strong>
                                (COD)</strong> you can pay in cash at the time of actual delivery of the product
                            at your doorstep. </p>
                     </div>
                </div>
            </div>
        </div>
    </section>


    </>);

}

export default PaymentMethod;